import axios from "axios";
import { PoiType } from "../types";
import { callWsCached } from "../utils";


function getPoiTypes(
  siteBasePath: string
  ): Promise<PoiType[]> {
    let url = `/api/poi/list-type`;
    url = `${siteBasePath}${url}`;
    return axios({ method: "get", url }).then(resp => {
      let poiTypes = Object.values(resp);
      return poiTypes;
    });
}

export default async function(
    siteBasePath: string,
    network: string
  ): Promise<PoiType[]> {
    let prefix = `server-${network}-${siteBasePath}-`;

    let proxyGetValue: Function = callWsCached(
      prefix + "poiTypes",
      () => getPoiTypes(siteBasePath.replace(/\/$/, ''))
    );

    let proxiedValue = await proxyGetValue();

    return JSON.parse(JSON.stringify(proxiedValue[0]));
  }
